import { render, staticRenderFns } from "./ReviewDashboard.vue?vue&type=template&id=6c6b893d&scoped=true&"
import script from "./ReviewDashboard.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboard.vue?vue&type=style&index=0&id=6c6b893d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b893d",
  null
  
)

export default component.exports